
import { Form, Table } from 'react-bootstrap';
export const renderQuestions = (question, index, handleChange, handleBlur, values, touched, errors, setFieldValue) => {
  switch (question.questionType) {
    case "Cuadro de texto con varias líneas":
      return (
        <Form.Group key={index}>
          <Form.Label>{question.name}</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name={`question_${index}`}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values[`question_${index}`]}
            isInvalid={errors[`question_${index}`]} />
          <Form.Text className="text-muted">
            {question.description}
          </Form.Text>
          <Form.Text>
            {errors[question.helperText]}
          </Form.Text>
          <Form.Control.Feedback type="invalid">
            {errors[`question_${index}`]}
          </Form.Control.Feedback>
        </Form.Group>
      )
    case "Cuadro de texto de una línea":
      return (
        <Form.Group key={index}>
          <Form.Label>{question.name}</Form.Label>
          <Form.Control
            type="text"
            name={`question_${index}`}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values[`question_${index}`]}
            isInvalid={errors[`question_${index}`]}
          />
          <Form.Text className="text-muted">
            {question.description}
          </Form.Text>
          <Form.Text>
            {errors[question.helperText]}
          </Form.Text>
          <Form.Control.Feedback type="invalid">
            {errors[`question_${index}`]}
          </Form.Control.Feedback>
        </Form.Group>
      )
      case 'Valor numérico':
        return (
          <Form.Group key={index}>
            <Form.Label>{question.name}</Form.Label>
            <Form.Control
              type="number"
              name={`question_${index}`}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values[`question_${index}`]}
              isInvalid={errors[`question_${index}`]}
            />
            <Form.Text className="text-muted">
              {question.description}
            </Form.Text>
            <Form.Text>
              {errors[question.helperText]}
            </Form.Text>
            <Form.Control.Feedback type="invalid">
              {errors[`question_${index}`]}
            </Form.Control.Feedback>
          </Form.Group>
        )
      case 'Fecha':
        return (
          <Form.Group key={index}>
            <Form.Label>{question.name}</Form.Label>
            <Form.Control
              type="date"
              name={`question_${index}`}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values[`question_${index}`]}
              isInvalid={errors[`question_${index}`]}
            />
             <Form.Text className="text-muted">
              {question.description}
            </Form.Text>
            <Form.Text>
              {errors[question.helperText]}
            </Form.Text>
            <Form.Control.Feedback type="invalid">
              {errors[`question_${index}`]}
            </Form.Control.Feedback>
          </Form.Group>
        )
        case 'Fecha y hora':
          return (
            <Form.Group key={index}>
              <Form.Label>{question.name}</Form.Label>
              <Form.Control
                type="datetime-local"
                name={`question_${index}`}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values[`question_${index}`]}
                isInvalid={errors[`question_${index}`]}
              />
              <Form.Text className="text-muted">
                {question.description}
              </Form.Text>
              <Form.Text>
                {errors[question.helperText]}
              </Form.Text>
              <Form.Control.Feedback type="invalid">
                {errors[`question_${index}`]}
              </Form.Control.Feedback>
            </Form.Group>
          )
        case 'Opción múltiple: solo una respuesta':
          return (
            <Form.Group key={index}>
              <Form.Label>{question.name}</Form.Label>
              {
                question.answers.map((answer, ind) => (
                  <Form.Check
                    key={ind}
                    type="radio"
                    label={answer.description}
                    name={`question_${index}`}
                    //value={values[`question_${index}`]}
                    checked={values[`question_${index}`] === answer.id}
                    onChange={() => setFieldValue(`question_${index}`, answer.id)}
                    onBlur={handleBlur}
                    isInvalid={errors[`question_${index}`]}
                  />
                ))
              }
               <Form.Text className="text-muted">
                {question.description}
              </Form.Text>
              <Form.Text>
                {errors[question.helperText]}
              </Form.Text>
             {
                errors[`question_${index}`] && (
                  <div className="text-danger">
                    {errors[`question_${index}`]}
                  </div>
                )
             }
            </Form.Group>
          )
        case 'Opción múltiple: se permiten varias respuestas': 
          return (
            <Form.Group key={index}>
              <Form.Label>{question.name}</Form.Label>
              {
                question.answers.map((answer, ind) => (
                  <Form.Check
                    key={ind}
                    type="checkbox"
                    label={answer.description}
                    name={`question_${index}`}
                    //value={values[`question_${index}`]}
                    checked={values[`question_${index}`]?.includes(answer.id)}
                    onChange={() => {
                      const selectedAnswers = values[`question_${index}`] || [];
                      if (selectedAnswers.includes(answer.id)) {
                        setFieldValue(
                          `question_${index}`, 
                          selectedAnswers.filter(id => id !== answer.id)
                        );
                      } else {
                        setFieldValue(
                          `question_${index}`, 
                          [...selectedAnswers, answer.id]
                        );
                      }
                    }}
                    onBlur={handleBlur}
                    isInvalid={errors[`question_${index}`]}
                  />
                ))
              }
              <Form.Text className="text-muted">
                {question.description}
              </Form.Text>
              <Form.Text>
                {errors[question.helperText]}
              </Form.Text>
              {
                errors[`question_${index}`] && (
                  <div className="text-danger">
                    {errors[`question_${index}`]}
                  </div>
                )
              }
            </Form.Group>
          )
        case 'Matriz':
          return (
            <div className="my-2" key={index}>
              <h6>{question.name}</h6>
              <Form.Text className="text-muted mb-3">
                {question.description}
              </Form.Text>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Pregunta</th>
                    {
                      question.answers.filter(column => column.type === 'Columna').map((option, colIndex) => (
                        <th key={colIndex}>{option.description}</th>
                      ))
                    }
                  </tr>
                </thead>
                <tbody>
                  {
                    question.answers.filter(fila => fila.type === 'Fila').map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        <td className={errors[`question_${index}`] ? 'bg-danger text-white' : ''}>{row.description}</td>
                        {
                          question.answers.filter(column => column.type === 'Columna').map((option, colIndex) => (
                            <td key={colIndex} className="text-center">
                              <Form.Check
                                type="radio"
                                name={`question_${index}.${rowIndex}.value`}
                                checked={values[`question_${index}`]?.[rowIndex]?.value === option.id}
                                onChange={() => setFieldValue(`question_${index}.${rowIndex}.value`, option.id)}
                                isInvalid={touched[`question_${index}.${rowIndex}.value`] && errors[`question_${index}.${rowIndex}.value`]}
                              />
                            </td>
                          ))
                        }
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
              {
                errors[`question_${index}`] && (
                  <div className="text-danger">
                    {errors[`question_${index}`]}
                  </div>
                )
              }
            </div>
          )
    default:
      return null
  }
}